"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findCountryCode;
function findCountryCode(tags) {
  for (var tagIndex = 0; tagIndex < tags.length; tagIndex++) {
    var tag = tags[tagIndex];
    var find = tag.match(/country\/(.*)?/);
    if (find) {
      return find[1];
    }
  }

  return undefined;
}


//////////////////
// WEBPACK FOOTER
// ./~/places.js/src/findCountryCode.js
// module id = 1629
// module chunks = 1